class Video {
  constructor() {
    this.settings = {
      videoSelector: '.js-video',
    };
  }

  init() {
    const videoSelector = $(this.settings.videoSelector);
    const $this = this;
    videoSelector.on({
      click(e) {
        e.preventDefault();
        $this.constructor.startVideo(this);
      },
    });
  }

  static startVideo(element) {
    const $element = $(element);
    const videoUrl = $element.attr('data-video') ? $element.attr('data-video') : false;
    const onylIframe = !!$element.attr('data-iframe');
    if (videoUrl) {
      $element.parent().css('background', 'transparent');
      $element.addClass('active');
      if (!onylIframe) {
        $element.html(`<div class="embed-responsive embed-responsive-16by9"> 
        <iframe src="${videoUrl}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen />
        </div>`);
      }
      if (onylIframe) {
        $element.parent().html(`
        <iframe src="${videoUrl}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen />
        `);
      }

    }
  }
}

export default Video;
